<template>
  <div id="photo">
    <!-- all_in -->
    <div class="break_box" v-if="!$route.meta.keepAliveSub">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_box">
        <div class="psear mb10">
          <input name="" type="text" class="psear_input" :placeholder="showPage.albumSearch" v-model="searchName">
          <button type="submit" class="gue_btn" @click="search">{{showPage.search}}</button>
        </div>
        <div class="photo_box" v-for="(album,index) in albums" :key="index" v-if="inCurrentPage(index)">
          <router-link :to="{ name: 'photo_in', params: { albumId: album.id } }">
            <div class="photo_box_icon">
              {{showMemo(album)}}
              <div class="mt10">
                <button type="submit" class="photo_btn">more</button>
              </div>
            </div>
            <div class="photo_box_pic"><img :src="album.coverPictureUrl"></div>
            <!--<div class="photo_box_pic"><img src="/../static/images/1.jpg"></div>-->
            <div class="photo_box_title">{{showName(album)}}</div>
            <div class="photo_box_tx">{{showPage.totalCount}}{{album.pictureCount}}{{showPage.item}}</div>
          </router-link>
        </div>
        <div class="fix"></div>
        <div class="pagination-row text-center ml20">
          <Page :current="currentPage" :total="albums.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
    </div>
    <router-view v-if="$route.meta.keepAliveSub" :outerphoto="albums"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'photo',
  data() {
    return {
      allAlbums: [],
      albums: [],
      searchName: '',
      currentPage: 1,
      pagesize: 12,
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initAlbums();
    },
    initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData() {
      axios.get(API.album)
        .then(response => {
          this.allAlbums = response.data;
          this.albums = this.allAlbums;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    search() {
      if (this.searchName) {
        this.albums = this.allAlbums.filter(row => {
          return Object.keys(row).some(key => {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(this.searchName) !== -1;
          });
        });
      } else
        this.albums = this.allAlbums;

      this.currentPage = 1;
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },

    showName(album) {
      let show = { 'CH': album.nameCh, 'EN': album.nameEn }
      return show[sessionStorage.locale];
    },
    showMemo(album) {
      let show = { 'CH': album.memoCh, 'EN': album.memoEn }
      return show[sessionStorage.locale];
    }
  },
}

</script>
<style lang="scss">
#photo {
  padding: 0 !important;
  .photo_box_pic {
    height: 200px;
    overflow: hidden;
  }
  .photo_box_title {
    height: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// Photo.vue?1731403b